import type { JSONSchema7 } from 'json-schema';

import type { DeepReadonly } from './types';

/* eslint-disable @typescript-eslint/naming-convention */
// We want these to match the API schema as closely as possible

export const cursorJsonSchema = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  type: 'object',
  properties: {
    max_tokens: {
      type: ['integer', 'null'],
      description: 'The maximum number of tokens that can be generated in the completion.',
      minimum: 1,
      maximum: 8192,
      default: 4096,
    },
    temperature: {
      type: ['number', 'null'],
      description: 'Sampling temperature for randomness in response generation.',
      minimum: 0,
      maximum: 2,
      default: 1,
    },
    top_p: {
      type: ['number', 'null'],
      description: 'Nucleus sampling probability threshold, limiting considered tokens.',
      minimum: 0,
      maximum: 1,
      default: 1,
    },
  },
  additionalProperties: false,
} as const;

// this confirms that the type is a valid JSON schema, but we want it as a `const` so we can use it to index the properties
export const cursorSchemaProperties: DeepReadonly<JSONSchema7> = cursorJsonSchema;

export const retrieveCursorParameters = (): string[] => Object.keys(cursorJsonSchema.properties);
